import React from "react";
import RouletteNav from "../../components/roulette/RouletteNav";
import DashboardRoulette from "../../components/roulette/DashboardRoulette";
import RouletteProvider from "../../store/roulette/RouletteProvider";

const Index = () => {
    return (
        <RouletteProvider>
            <div className="main-w">
                <div className="main">
                    <div className="w-1200">
                        <RouletteNav />
                        <DashboardRoulette />
                    </div>
                </div>
            </div>
        </RouletteProvider>
    );
};

export default Index;